var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Cập nhật ngày lễ",
        visible: _vm.dialogVisible,
        width: "1000px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "3vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "newCelebrateSample",
          attrs: {
            "label-width": "130px",
            model: _vm.newCelebrateSample,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Đối tượng", prop: "type" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.newCelebrateSample.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.newCelebrateSample, "type", $$v)
                    },
                    expression: "newCelebrateSample.type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "Học sinh" } }, [
                    _vm._v("Học sinh"),
                  ]),
                  _c("el-radio", { attrs: { label: "Phụ huynh" } }, [
                    _vm._v("Phụ huynh"),
                  ]),
                  _c("el-radio", { attrs: { label: "Giáo viên" } }, [
                    _vm._v("Giáo viên"),
                  ]),
                  _c("el-radio", { attrs: { label: "Nhà trường" } }, [
                    _vm._v("Nhà trường"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Chủ đề", prop: "title" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập chủ đề" },
                model: {
                  value: _vm.newCelebrateSample.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.newCelebrateSample, "title", $$v)
                  },
                  expression: "newCelebrateSample.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { display: "inline-block", width: "30%" },
              attrs: { label: "Chọn ngày", prop: "date" },
            },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Chọn ngày" },
                  model: {
                    value: _vm.newCelebrateSample.date,
                    callback: function ($$v) {
                      _vm.$set(_vm.newCelebrateSample, "date", $$v)
                    },
                    expression: "newCelebrateSample.date",
                  },
                },
                _vm._l(_vm.dateList, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { float: "right", "margin-left": "15px" },
              attrs: { label: "Giới tính", prop: "gender" },
            },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Giới tính" },
                  model: {
                    value: _vm.newCelebrateSample.gender,
                    callback: function ($$v) {
                      _vm.$set(_vm.newCelebrateSample, "gender", $$v)
                    },
                    expression: "newCelebrateSample.gender",
                  },
                },
                _vm._l(_vm.genderList, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { float: "right", width: "30%" },
              attrs: { label: "Chọn tháng", prop: "month" },
            },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Chọn tháng" },
                  model: {
                    value: _vm.newCelebrateSample.month,
                    callback: function ($$v) {
                      _vm.$set(_vm.newCelebrateSample, "month", $$v)
                    },
                    expression: "newCelebrateSample.month",
                  },
                },
                _vm._l(_vm.monthList, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Nội dung", prop: "content" } },
            [
              _c("el-input", {
                attrs: {
                  rows: 3,
                  type: "textarea",
                  placeholder: "Nhập nội dung",
                },
                model: {
                  value: _vm.newCelebrateSample.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.newCelebrateSample, "content", $$v)
                  },
                  expression: "newCelebrateSample.content",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Chọn ảnh" } },
            [
              _vm.newCelebrateSample.urlPicture != null &&
              _vm.showPicutreInitial
                ? _c("el-image", {
                    staticStyle: {
                      width: "150px",
                      height: "150px",
                      float: "left",
                      "margin-right": "20px",
                    },
                    attrs: {
                      src: _vm.newCelebrateSample.urlPicture,
                      fit: "fill",
                    },
                  })
                : _vm._e(),
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticClass: "avatar-uploader",
                  class: { hideUpload: !_vm.showUpload },
                  attrs: {
                    "show-file-list": true,
                    "list-type": "picture-card",
                    "on-change": _vm.handleChangeUpload,
                    "on-remove": _vm.handleRemove,
                    "auto-upload": false,
                    limit: "1",
                  },
                },
                [
                  _vm.newCelebrateSample.urlPicture != null
                    ? _c("span", [
                        _c(
                          "i",
                          {
                            staticClass: "el-icon-plus",
                            staticStyle: { "font-size": "20px" },
                          },
                          [_vm._v("Cập nhật ảnh")]
                        ),
                      ])
                    : _c("span", [
                        _c(
                          "i",
                          {
                            staticClass: "el-icon-plus",
                            staticStyle: { "font-size": "20px" },
                          },
                          [_vm._v("Thêm ảnh")]
                        ),
                      ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("newCelebrateSample")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("newCelebrateSample")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }